// extracted by mini-css-extract-plugin
export var fileExt = "_sg-8";
export var fileIcon = "_sg-6";
export var fileLink = "_sg-5";
export var fileName = "_sg-7";
export var image = "_sg-1";
export var imageError = "_sg-3";
export var imageErrorIcon = "_sg-4";
export var imageLink = "_sg-0";
export var imageLoaded = "_sg-2";